import { FirestoreDataConverter } from '@angular/fire/firestore';
import { Address } from './address.model';
import { ShipmentStateEnum } from '../enums/shipment-state.enum';
import { TransporterEnum } from '../enums/transporter.enum';
import { TransportCategoryEnum } from '../enums/transport-category.enum';
import { SourceType } from "../enums/source-type.enum";

export class Shipment {
  id: string;
  shipmentKey: string;
  customerId: string;
  description: string;
  version: string;
  format: string;
  reference: string;
  transactionId: string;
  orderId: string;
  productId: string;
  shipDate: string;
  shipTime: string;
  departure: string;
  trackingId: string;
  trackingUrl: string;
  weight: number;
  quantity: number;
  shipTo: Address;
  shipFrom: Address;
  transporterId: TransporterEnum;
  transportCategory: TransportCategoryEnum;
  overridden: boolean;
  state: ShipmentStateEnum;
  siteId: string;
  salesId: string;
  batFile: string;
  remark: string;
  supplementaryData: string;
  orderName: string;
  stateDate: Date;
  stateText: string;
  deliveryDate: Date;
  webShipmentId: string;
  express: boolean;
  courier: boolean;
  pickUp: boolean;
  charter: boolean;
  external: boolean;
  support: string;
  lockComment: string;
  lockedBy = 'none';
  lockerName: string;
  lockDate: Date;
  operator: string;
  conditioning: string;
  source: SourceType;
  organizationId: string;
  erpId: string;
  poId: string;

  constructor(shipment?: Partial<Shipment>) {
    this.id = shipment?.id ?? '';
    this.shipmentKey = shipment?.shipmentKey ?? '';
    this.customerId = shipment?.customerId ?? '';
    this.description = shipment?.description ?? '';
    this.version = shipment?.version ?? '';
    this.format = shipment?.format ?? '';
    this.reference = shipment?.reference ?? '';
    this.transactionId = shipment?.transactionId ?? '';
    this.orderId = shipment?.orderId ?? '';
    this.productId = shipment?.productId ?? '';
    this.shipDate = shipment?.shipDate ?? '';
    this.shipTime = shipment?.shipTime ?? '';
    this.departure = shipment?.departure ?? '';
    this.trackingId = shipment?.trackingId ?? '';
    this.trackingUrl = shipment?.trackingUrl ?? '';
    this.weight = shipment?.weight ?? 0;
    this.quantity = shipment?.quantity ?? 0;
    this.shipTo = shipment?.shipTo ?? null;
    this.shipFrom = shipment?.shipFrom ?? null;
    this.transporterId = shipment?.transporterId ?? TransporterEnum.UNKNOWN;
    this.transportCategory = shipment?.transportCategory ?? TransportCategoryEnum.UNKNOWN;
    this.overridden = shipment?.overridden ?? false;
    this.state = shipment?.state ?? ShipmentStateEnum.TO_SHIP;
    this.siteId = shipment?.siteId ?? '';
    this.salesId = shipment?.salesId ?? '';
    this.batFile = shipment?.batFile ?? '';
    this.stateDate = shipment?.stateDate ?? null;
    this.stateText = shipment?.stateText ?? '';
    this.deliveryDate = shipment?.deliveryDate ?? null;
    this.remark = shipment?.remark ?? '';
    this.supplementaryData = shipment?.supplementaryData ?? '';
    this.orderName = shipment?.orderName ?? '';
    this.webShipmentId = shipment?.webShipmentId ?? '';
    this.express = shipment?.express ?? false;
    this.courier = shipment?.courier ?? false;
    this.pickUp = shipment?.pickUp ?? false;
    this.charter = shipment?.charter ?? false;
    this.external = shipment?.external ?? false;
    this.support = shipment?.support ?? '';
    this.lockComment = shipment?.lockComment ?? '';
    this.lockedBy = shipment?.lockedBy ?? 'none';
    this.lockerName = shipment?.lockerName ?? '';
    this.lockDate = shipment?.lockDate ?? null;
    this.operator = shipment?.operator ?? null;
    this.conditioning = shipment?.conditioning ?? '';
    this.source = shipment?.source ?? SourceType.OKTO;
    this.organizationId = shipment?.organizationId ?? '';
    this.erpId = shipment?.erpId ?? '';
    this.poId = shipment?.poId ?? '';
  }

  /**
   * Converter used to convert a shipment from firebase
   */
  static converter: FirestoreDataConverter<Shipment> = {
    toFirestore: (shipment: Shipment) => {
      return shipment;
    },
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new Shipment({
        ...snapshot.data(options),
        id: snapshot.id,
        stateDate: data.stateDate ? new Date(data.stateDate.seconds * 1000) : null,
        deliveryDate: data.deliveryDate ? new Date(data.deliveryDate.seconds * 1000) : null,
        lockDate: data.lockDate ? new Date(data.lockDate.seconds * 1000) : null,
        customerId: String(data.customerId)
      });
    }
  };
}
